// Module
var code = "<button class=\"button\" d-option=\":optionValue\"> <span class=\"icon is-small is-hidden\"> <i class=\"fa-solid fa-check\"></i> </span> <span>:optionLabel</span> </button> ";
// Exports
export default code;